import PropTypes from "prop-types";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";

import { FleetContext } from "../../context";
import { FilledTextField } from "../../components/FormElements";
import { capitalize } from "../../util/helpers";


/**
 *
 * @param form : The form object
 * @param field: The form field
 * @param callback: A callback function to be passed in
 * @param otherProps: Other properties as desired
 * @returns A jsx with the specified params
 */

const ScheduleRuleField = ({ form, field, showTz, callback, otherProps }) => {
  const { t } = useTranslation();
  const { activeFleet } = useContext(FleetContext);
  const theme = useTheme();

  const getFieldLabel = () => {
    const fieldName = t(`Fleet.Geofences.ScheduleRules.${capitalize(field)}`);
    const tz = showTz ? `, ${activeFleet.timezone}` : "";
    return fieldName + tz;
  };

  return (
    <FilledTextField
      value={form[field]}
      label={getFieldLabel()}
      underlineColor={theme.palette.text.lightgrey}
      onChange={(e) => callback(e)}
      InputLabelProps={{ shrink: true }}
      {...otherProps}
    />
  );
};

ScheduleRuleField.propTypes = {
  field: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  showTz: PropTypes.bool,
  otherProps: PropTypes.object,
  callback: PropTypes.func,
};

ScheduleRuleField.defaultProps = {
  showTz: false,
  otherProps: {},
  callback: () => {},
};

export default ScheduleRuleField;
